import { render, staticRenderFns } from "./FormationsManagerItem.vue?vue&type=template&id=a5291266&scoped=true&"
import script from "./FormationsManagerItem.vue?vue&type=script&lang=js&"
export * from "./FormationsManagerItem.vue?vue&type=script&lang=js&"
import style0 from "./FormationsManagerItem.vue?vue&type=style&index=0&id=a5291266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5291266",
  null
  
)

export default component.exports